// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
// Backend de usuarios (JWT + MySQL)
// Cambia el puerto si tu backend corre en otro
// Use Vite environment variable VITE_API_BASE when provided (e.g. http://192.168.2.220:3001)
// Fallback to the previous localhost value to preserve current behavior.
export const backendBaseUrl = import.meta.env.VITE_API_BASE || 'http://127.0.0.1:3002';
